import { combineReducers, Reducer } from 'redux';

import * as types from './user-form.types';
import * as constants from './user-form.constants';
import { isActionOfType } from '../../../../../utils/action.utils';

const initialState: types.IUserFormState = {
  selectableAccounts: [],
  selectableTeams: [],
  formAvatar: '',
  cropCounter: 0,
  formFile: '',
};

const selectableAccountsReducer: Reducer<
  types.IUserFormState['selectableAccounts'],
  types.IStoreSelectableAccounts | types.IClearSelectableAccounts
> = (state = initialState.selectableAccounts, action) => {
  if (isActionOfType<types.IStoreSelectableAccounts>(action, constants.STORE_SELECTABLE_ACCOUNTS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearSelectableAccounts>(action, constants.CLEAR_SELECTABLE_ACCOUNTS)) {
    return initialState.selectableAccounts;
  }
  return state;
};

const selectableTeamsReducer: Reducer<
  types.IUserFormState['selectableTeams'],
  types.IStoreSelectableTeams | types.IClearSelectableTeams
> = (state = initialState.selectableTeams, action) => {
  if (isActionOfType<types.IStoreSelectableTeams>(action, constants.STORE_SELECTABLE_TEAMS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearSelectableTeams>(action, constants.CLEAR_SELECTABLE_TEAMS)) {
    return initialState.selectableTeams;
  }
  return state;
};

const formAvatarReducer: Reducer<types.IUserFormState['formAvatar'], types.ISaveFormAvatar | types.IClearFormAvatar> = (
  state = initialState.formAvatar,
  action,
) => {
  if (isActionOfType<types.ISaveFormAvatar>(action, constants.SAVE_FORM_AVATAR)) {
    return action.payload;
  } else if (isActionOfType<types.IClearFormAvatar>(action, constants.CLEAR_FORM_AVATAR)) {
    return initialState.formAvatar;
  }
  return state;
};

const cropCounterReducer: Reducer<
  types.IUserFormState['cropCounter'],
  types.ISaveCropCounter | types.IClearCropCounter
> = (state = initialState.cropCounter, action) => {
  if (isActionOfType<types.ISaveCropCounter>(action, constants.SAVE_CROP_COUNTER)) {
    return action.payload;
  } else if (isActionOfType<types.IClearCropCounter>(action, constants.CLEAR_CROP_COUNTER)) {
    return initialState.cropCounter;
  }
  return state;
};

const formFileReducer: Reducer<types.IUserFormState['formFile'], types.ISaveFormFile | types.IClearFormFile> = (
  state = initialState.formFile,
  action,
) => {
  if (isActionOfType<types.ISaveFormFile>(action, constants.SAVE_FORM_FILE)) {
    return action.payload;
  } else if (isActionOfType<types.IClearFormFile>(action, constants.CLEAR_FORM_FILE)) {
    return initialState.formFile;
  }
  return state;
};

export const userFormReducer: Reducer<types.IUserFormState, types.IUserFormAction> = combineReducers({
  selectableAccounts: selectableAccountsReducer,
  selectableTeams: selectableTeamsReducer,
  formAvatar: formAvatarReducer,
  cropCounter: cropCounterReducer,
  formFile: formFileReducer,
});
